import { AppHeader } from '../AppHeader';
import { OrganizationPanel } from './OrganizationPanel';
export function OrganizationPage() {
  return <><AppHeader back={{to:'/missions',label:'Back to shoots'}}/><main className="page page--narrow"><div className="page-heading"><div className="eyebrow">Team workspace</div><h1>Organization</h1><p className="muted">People, aircraft sources, shared fleet and team rules in one place.</p></div><OrganizationPanel/></main></>;
}
